var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OptionsForm',{ref:"form",attrs:{"fields":_vm.formFields,"omitFields":_vm.omitFields},on:{"submit":_vm.onSubmit},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }